(function () {
    if (!window.location.pathname.match(/\/car-rental-franchise(\/.+)?/g)) return;

    $('a[href^="#"]').on('click', function (e) {
        e.preventDefault();

        var target = this.hash,
            $target = $(target);

        if (!$target.offset()) return;

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $target.offset().top,
                },
                900,
                'swing',
                function () {
                    window.location.hash = target;
                }
            );
    });
})();
